<template>
    <CRow>
      <CCol col="12" xl="12">
        <transition name="slide">
          <CCard>
            <CCardHeader>
              Promotions
              <CButton size="sm" style="float:right;" color="success" @click="addModal = true">Add Promotion</CButton>
            </CCardHeader>
            <CCardBody>
              <CAlert :show.sync="dismissCountDown" color="primary" fade>
                ({{dismissCountDown}}) {{ message }}
              </CAlert>
              <CDataTable
                :items="items"
                :fields="fields"
                column-filter
                table-filter
                :items-per-page="10"
                pagination
              >
                <template #edit="{item}">
                  <td>
                    <CButton size="sm" color="primary" @click="edit(item.id)">Edit</CButton>
                  </td>
                </template>
              </CDataTable>
            </CCardBody>
          </CCard>
        </transition>
  
        <CModal title="Add Promotion" :show.sync="addModal">
          <CForm>
            <CInput label="Name" :value.sync="form.name" placeholder="Promotion Name" />
            <CTextarea label="Description" :value.sync="form.description" placeholder="Promotion Description" />
            <CInput label="Min Quantity Required" type="number" :value.sync="form.min_quantity_required" />
  
            <div style="padding-bottom:15px;">
              <label>Discount Type</label>
              <v-select v-model="form.discount_type" :options="discountTypes" placeholder="Select Type" />
            </div>

            <div v-if="form.discount_type === 'shipping_discount' && shipViaOptions" style="padding-bottom:15px;">
              <label>Ship Via Type</label>
              <!-- <v-select v-model="form.ship_to_type" :options="shipViaOptions" placeholder="Select Type" /> -->
              <v-select
                  v-model="form.ship_to_type"
                  v-if="shipViaOptions"
                  :options="shipViaOptions"
                  placeholder="Select Ship Via"
                  label="ship_via_text"
              >
                <template slot="option" slot-scope="option">
                  {{option['ship_via_code']}} - {{option['ship_via_text']}}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{option.ship_via_code}} - {{option.ship_via_text}}
                </template>
              </v-select>
            </div>
  
            <CInput label="Discount Value" type="number" :value.sync="form.discount_value" />
  
            <div style="padding-bottom:15px;">
              <label>Applies To Current Order?</label>
              <CButton size="sm" @click="form.applies_to_current_order = true" :color="form.applies_to_current_order ? 'success' : 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.applies_to_current_order = false" style="margin-left:5px;" :color="!form.applies_to_current_order ? 'danger': 'outline-danger'">No</CButton>
            </div>

            <div style="padding-bottom:15px;">
              <label>Allow This Promotion To Stack With Prebook?</label>
              <CButton size="sm" @click="form.allows_stackable = true" :color="form.allows_stackable ? 'success' : 'outline-success'">Yes</CButton>
              <CButton size="sm" @click="form.allows_stackable = false" style="margin-left:5px;" :color="!form.allows_stackable ? 'danger': 'outline-danger'">No</CButton>
            </div>

            <div v-if="form.allows_stackable" class="prebook-combinations">
              <div class="prebook-combinations-heading">
                <div>
                  <label>Allowed Prebook Combinations</label>
                  <small>Select each allowed prebook and enter its combined NetSuite internal ID.</small>
                </div>
                <CButton type="button" size="sm" color="primary" @click="addPrebookCombination">Add</CButton>
              </div>
              <div v-for="(combination, index) in form.prebook_combinations" :key="index" class="prebook-combination-row">
                <div>
                  <label>Prebook Option</label>
                  <v-select
                    v-model="combination.prebook_option"
                    :options="prebookOptions"
                    label="pre_book_label"
                    placeholder="Select Prebook Option"
                  />
                </div>
                <div>
                  <label>Combined NetSuite Internal ID</label>
                  <input class="form-control" v-model="combination.combined_with_promo_internal_id" />
                </div>
                <CButton class="combination-remove" type="button" size="sm" color="outline-danger" @click="removePrebookCombination(index)">Remove</CButton>
              </div>
              <div v-if="!form.prebook_combinations.length" class="prebook-combinations-empty">No prebook combinations have been added yet.</div>
            </div>

            <div style="padding-bottom:15px;">
              <label>Product Classes (leave empty for all)</label>
              <!-- <v-select v-model="form.product_classes" :options="productClasses" :reduce="pc => pc.product_class" value="product_class" label="product_class" multiple placeholder="Select Product Class" /> -->
              <v-select
                v-model="form.product_classes"
                :options="productClasses"
                :reduce="pc => pc.product_class"
                label="product_class"
                multiple
                placeholder="Select Product Class"
              />
            </div>

            <div style="padding-bottom:15px;" v-if="!form.applies_to_current_order">
              <label>Product Classes Allowed On New Promo Order (leave empty for all)</label>
              <v-select
                v-model="form.bonus_product_classes"
                :options="productClasses"
                :reduce="pc => pc.product_class"
                label="product_class"
                multiple
                placeholder="Select Product Class"
              />
            </div>

            <div style="padding-bottom:15px;">
              <label>Techniques (leave empty for all)</label>
              <v-select
                v-model="form.technique_ids"
                :options="techniques"
                :reduce="t => t.technique_id"
                label="technique_name"
                multiple
                placeholder="Select Techniques"
                :get-option-label="techniqueOptionLabel"
              />
            </div>

            <div style="width:100%;float:left;padding-bottom:15px;">
              <label>User Types (leave empty for all)</label>
              <multiselect v-model="form.user_types" :options="userTypeOptions" :multiple="true" />
            </div>
  
            <div style="width:100%;float:left;padding-bottom:15px;">
              <label>Programs This Applies To</label>
              <multiselect v-model="form.programs" :options="programs" :multiple="true" label="program_name" track-by="program_id" />
            </div>
  
            <div style="width:100%;float:left;padding-bottom:15px;">
              <label>Used On These Programs (if all leave blank)</label>
              <multiselect v-model="form.bonus_programs" :options="programs" :multiple="true" label="program_name" track-by="program_id" />
            </div>

            <div style="padding-bottom:15px;">
                <label>Upload Promotion PDF</label>
                <input type="file" @change="handleFileUpload" />
            </div>

            <CInput
                label="Ends At"
                type="date"
                :value.sync="form.ends_at"
                />
          </CForm>
          <template #footer>
            <CButton @click="addModal = false; reset()" color="danger">Cancel</CButton>
            <CButton @click="add()" color="success">Add</CButton>
          </template>
        </CModal>
      </CCol>
    </CRow>
  </template>
  
  <script>
  import Multiselect from 'vue-multiselect';
  export default {
    name: 'Promotions',
    components: { Multiselect },
    data() {
      return {
        items: [],
        fields: ['name', 'description', 'min_quantity_required', 'discount_type', 'discount_value', 'edit'],
        addModal: false,
        form: this.getForm(),
        productClasses: '',
        message: '',
        dismissCountDown: 0,
        discountTypes: ['free_item', 'free_item_same_order', 'discount', 'per_unit_dollar_discount', 'free_locations', 'shipping_discount'],
        programs: [],
        techniques: [],
        userTypeOptions: [],
        shipViaOptions: [],
        prebookOptions: []
      }
    },
    mounted() {
      this.getData()
      this.getPrograms()
      this.getTechniques()
      this.getProductClasses()
      this.getUserTypes()
      this.getShipViaOptions()
      this.getPrebookOptions()
    },
    methods: {
      getForm() {
        return {
            name: '',
            description: '',
            min_quantity_required: '',
            discount_type: '',
            discount_value: '',
            product_classes: [],
            bonus_product_classes: [],
            applies_to_current_order: true,
            allows_stackable: false,
            prebook_combinations: [],
            programs: [],
            bonus_programs: [],
            pdf: null,
            ends_at: '',
            user_types: [],
            ship_to_type: null,
            technique_ids: []
        }
      },
      reset() {
        this.form = this.getForm();
      },
      getData() {
        axios.get(this.$apiAdress + '/api/promotions?token=' + localStorage.getItem("api_token"))
          .then(response => this.items = response.data)
          .catch(error => console.error(error));
      },
      getPrograms() {
        axios.get(this.$apiAdress + '/api/programs?token=' + localStorage.getItem("api_token"))
          .then(response => this.programs = response.data)
          .catch(error => console.error(error));
      },
      getUserTypes() {
        axios.get(this.$apiAdress + '/api/roles?token=' + localStorage.getItem('api_token')).then(response => {
          console.log(response)
          // this.roles = response.data
          var that = this
          this.userTypeOptions = []
          response.data.forEach(function (val) {
            that.userTypeOptions.push(val.name)
          })
        })
      },
      getShipViaOptions() {
        let self = this
        const postData = {
          type: 'all'
        }
        axios.post( this.$apiAdress + '/api/ship_vias/getOrderShipVias?token=' + localStorage.getItem("api_token"), postData)
        .then(function (response) {
          console.log(response)
          self.shipViaOptions = response.data
        }).catch(function (error) {
          console.log(error)
        });
      },
      getProductClasses() {
        axios
        .post(this.$apiAdress + '/api/styles/getProductClasses?token=' + localStorage.getItem("api_token"))
        .then(({data}) => {
          // Accept either [{product_class: 'HEADWEAR'}] or ['HEADWEAR']
          this.productClasses = Array.isArray(data) && data.length && typeof data[0] === 'string'
            ? data.map(pc => ({ product_class: pc }))
            : data;
        })
        .catch(console.error);
      },
      techniqueOptionLabel(technique) {
        if (!technique) return '';
        const programs = (technique.programs || [])
          .map(program => program.program_name)
          .filter(Boolean)
          .join(', ');
        const assignment = programs || 'No program assigned';
        return `${technique.technique_name} — ${assignment} (ID ${technique.technique_id})`;
      },
      getTechniques() {
        axios.get(this.$apiAdress + '/api/techniques?token=' + localStorage.getItem("api_token"))
          .then(response => this.techniques = response.data)
          .catch(error => console.error(error));
      },
      getPrebookOptions() {
        axios.post(this.$apiAdress + '/api/getPrebookOptions?token=' + localStorage.getItem('api_token'))
          .then(response => this.prebookOptions = response.data)
          .catch(console.error);
      },
      addPrebookCombination() {
        this.form.prebook_combinations.push({
          prebook_option: null,
          combined_with_promo_internal_id: ''
        });
      },
      removePrebookCombination(index) {
        this.form.prebook_combinations.splice(index, 1);
      },
      handleFileUpload(event) {
        this.form.pdf = event.target.files[0];
      },
      add() {
        const formData = new FormData();

        Object.entries(this.form).forEach(([key, val]) => {
          if (key === 'prebook_combinations') {
            (val || []).forEach((combination, i) => {
              if (!combination.prebook_option) return;
              formData.append(`prebook_combinations[${i}][prebook_option_id]`, combination.prebook_option.id);
              formData.append(`prebook_combinations[${i}][combined_with_promo_internal_id]`, combination.combined_with_promo_internal_id);
            });
            return;
          }

          if (key === 'ship_to_type' && val && typeof val === 'object') {
            Object.entries(val).forEach(([k, v]) => {
              // e.g. ship_to_type[ship_via_code], ship_to_type[ship_via_text]
              formData.append(`ship_to_type[${k}]`, v);
            });
            return; // skip normal handling for ship_to_type
          }

          if (Array.isArray(val)) {
            val.forEach(v => {
              if (key === 'programs' || key === 'bonus_programs') {
                // v can be object or id; prefer program_id if present
                formData.append(`${key}[]`, v?.program_id ?? v);
              } else if (key === 'technique_ids') {
                formData.append('technique_ids[]', v);
              } else if (key === 'product_classes' || key === 'bonus_product_classes') {
                formData.append(`${key}[]`, v);
              } else {
                formData.append(`${key}[]`, v);
              }
            });
          } else if (val !== null && val !== undefined) {
            formData.append(key, val);
          }
        });

        axios.post(
          this.$apiAdress + '/api/promotions/store?token=' + localStorage.getItem("api_token"),
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        .then(() => {
          this.message = 'Promotion added successfully!';
          this.dismissCountDown = 5;
          this.getData();
          this.addModal = false;
          this.reset();
        })
        .catch(err => {
          this.message = 'Something went wrong.';
          this.dismissCountDown = 5;
          console.error(err);
        });
      },
      edit(id) {
        this.$router.push({ path: '/promotions/' + id + '/edit' });
      }
    }
  }
  </script>

  <style scoped>
  .prebook-combinations {
    clear: both;
    padding: 15px 0;
  }

  .prebook-combinations-heading {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
    margin-bottom: 12px;
  }

  .prebook-combinations-heading label {
    display: block;
    font-weight: 600;
    margin-bottom: 2px;
  }

  .prebook-combination-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
    align-items: end;
    margin-bottom: 12px;
    padding: 12px;
    border: 1px solid #d8dbe0;
    border-radius: 6px;
    background: #f8f9fa;
  }

  .prebook-combination-row label {
    font-weight: 600;
  }

  .combination-remove {
    justify-self: start;
  }

  .prebook-combinations-empty {
    padding: 12px;
    color: #6c757d;
    text-align: center;
    border: 1px dashed #c8ced3;
    border-radius: 6px;
  }
  </style>
